import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.object.seal";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import { mapGetters } from 'vuex';
export default {
  name: 'ConfiguratorTcVars',
  data: function data() {
    return {
      tcVars: Object.seal({
        env_country: '',
        env_language: '',
        env_template: 'Configurateur',
        page_url: this.$route.path,
        ga_activated: 1,
        user_email: '',
        user_id: '',
        user_category: '',
        user_firstvisit_date: '',
        user_logged: false,
        earlybirds_widgets: null
      })
    };
  },
  computed: _objectSpread({}, mapGetters({
    user: 'user/me',
    locale: 'i18n/locale'
  })),
  created: function created() {
    var _this = this;

    this.setTcVars('init configurator');
    this.$root.$on('reset-tcvars', function () {
      _this.setTcVars('configurator reset tcVars');
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$root.$off('reset-tcvars');
  },
  methods: {
    setTcVars: function setTcVars(message) {
      this.tcVars.env_country = this.locale.market;
      this.tcVars.env_language = this.locale.language;
      this.tcVars.user_logged = Boolean(this.user);

      if (this.user && process.client) {
        this.tcVars.user_email = window.localStorage.getItem('MDM_MAIL') || '';
        this.tcVars.user_id = this.user.id;
        this.tcVars.user_category = this.$cookies.get('MDM[statut]') || this.user.type || '';
        this.tcVars.user_firstvisit_date = this.$cookies.get('MDM[date_first_visit]');
      }

      if (process.client) {
        this.tcVars.earlybirds_widgets = JSON.parse(localStorage.getItem('EARLYBIRDS_WIDGETS'));
      }

      if (process.client && window.ga === undefined) {
        this.tcVars.ga_activated = 0;
      }

      if (process.client && this.$cookies.get('debugmdm')) {
        console.log(message, _objectSpread({}, this.tcVars));
      }

      this.$root.$emit('updated-tcvars', this.tcVars);
    }
  },
  render: function render(h) {
    return h(null);
  }
};